import React, { useEffect, useState, useContext, useMemo } from "react";
import { CompactCol, FlexColumn, SmallText, Spacer, UltraMediumText, SLGridLayout, SLRowLayout } from "../../components/core/utility";
import { Col, Grid, Row } from "@vds/grids";
import styled from "@emotion/styled";
import DocumentFlowTable, { CustomisedTable, CustomSmallText, customTableHeader } from "./DocumentFlowTable";
import MMIDLevelDocumentTable from "./MMIDLevelDocumentTable";
import { MaterialSOInfoTable } from "./MaterialSOInfoTable";
import moment from "moment";
import { C4SContext } from "../../context/c4sContext";
import { Cell, TableBody, TableHead, TableHeader, TableRow } from "@vds/tables";

const TrackingColumn = styled(Col)`
  padding: 0.5rem;
  flex-basis: 14%;
  max-width: 14%;
  min-width: 170px;
`;
const ColumnOne = styled(CompactCol)``;

const ColumnTwo = styled(CompactCol)`
  min-width: 302px;
  flex-basis: 23%;
  max-width: 23%;
`;

const ColumnThree = styled(CompactCol)`
  flex-basis: 21%;
  max-width: 23%;
  @media screen and (min-width: 1232px) {
    flex-basis: 23%;
  }
`;
const TableWrapper = styled.div`
  width: 80%;
  margin: auto;
`;

const ReturnESNTable = ({ data }) => {
  return (
    <CustomisedTable role="table">
      <TableHead role="row">
        <TableHeader role="columnheader">
          <CustomSmallText bold>ESNs to be Returned</CustomSmallText>
        </TableHeader>
      </TableHead>
      <TableBody role="rowgroup">
        <TableRow role="row">
          <Cell role="cell">
            <CustomSmallText>{data || "--"}</CustomSmallText>
          </Cell>
        </TableRow>
      </TableBody>
    </CustomisedTable>
  );
};

// Utility function to handle carriers data formatting
const formatCarriersData = (carriers) => {
  // Handle null or undefined
  if (!carriers) {
    return "--";
  }

  // Handle array of carriers
  if (Array.isArray(carriers)) {
    return (
      carriers
        .map((item) => {
          // If array item is an object, map to carrier property instead of id
          if (typeof item === "object" && item !== null) {
            return item.carrier || item.name || item.carrierName || "";
          }
          // If array item is a string, use it directly
          return item || "";
        })
        .filter((carrier) => carrier && String(carrier).trim() !== "") // Remove empty values
        .join(", ") || "--"
    );
  }

  // Handle object carriers - map to carrier property instead of id
  if (typeof carriers === "object") {
    // Priority mapping to carrier property
    if (carriers.carrier) {
      return carriers.carrier;
    }
    if (carriers.name) {
      return carriers.name;
    }
    if (carriers.carrierName) {
      return carriers.carrierName;
    }

    // Extract carrier values, excluding id property
    const carrierValues = Object.entries(carriers)
      .filter(
        ([key, value]) =>
          key !== "id" && // Exclude id property
          typeof value === "string" &&
          value.trim() !== ""
      )
      .map(([key, value]) => value)
      .join(", ");

    if (carrierValues) {
      return carrierValues;
    }

    // If no valid carrier values found, return fallback
    return "--";
  }

  // Handle string carriers
  if (typeof carriers === "string") {
    return carriers.trim() || "--";
  }

  // Handle number or other primitive types
  if (typeof carriers === "number" || typeof carriers === "boolean") {
    return String(carriers);
  }

  // Final fallback
  return "--";
};

export const MMIDFlyOutView = ({ data, vehicleInfoList, workTicketData, workticketId, ticketType }) => {
  const [trackingData, setTrackingData] = useState([]);
  const [documentFlowData, setDocumentFlowData] = useState();
  const [MMIDLevelDocumentData, setMMIDLevelDocumentData] = useState();
  const [bundleId, setBundleId] = useState([]);
  const [contractedPrice, setContractedPrice] = useState();
  const [totalQuantity, setTotalQuantity] = useState();
  const { isSourceCSP } = useContext(C4SContext);
  let cspCaseData = JSON.parse(sessionStorage.getItem("CSPDetails")),
    erpProviderNumber = "--",
    customerPONumber = "--";
  if (isSourceCSP.isSourceCSP) {
    erpProviderNumber = cspCaseData.CSP?.filter((cspData) => cspData.DefaultCSP === "1")[0]?.Provider_Order ?? "--";
    customerPONumber = cspCaseData?.CSP_CUstomer_PO_Number ?? "--";
  }
  useEffect(() => {
    let trackingListData = [
      {
        trackingId: "--",
        esn: "--",
      },
      {
        trackingId: "--",
        esn: "",
      },
    ];
    let documentData = {
      salesOrder: [1],
      deliveryNumber: [0, 567, 5678],
      purchaseOrder: [1],
      returnDelivery: [0],
    };
    let documentFlowMMIDLevelData = {
      pending: [0],
      ordered: [1],
      shipped: [0],
      scheduled: [1],
      unscheduled: [1],
      installed: [0],
      remaining: [0],
      selfInstalled: [0],
      shippedAccessories: [0],
      returnHardware: [0],
      returnAccessory: [0],
      emptyColumn: "",
    };
    setMMIDLevelDocumentData(documentFlowMMIDLevelData);
    setDocumentFlowData(documentData);
    setTrackingData(trackingListData);
    let bundleIdData = [];
    // if (workticketId.startsWith("W")) {
    //   vehicleInfoList.map((record) => {
    //     record?.materialList.map((material) => {
    //       if (material.materialId === data.MMID) {
    //         bundleIdData.push(material.bundleId);
    //       }
    //     });
    //   });
    // } else {
    workTicketData.map((material) => {
      if (material.MMID === data.MMID) {
        bundleIdData.push(material.bundleId);
      }
    });
    // }
    setBundleId([...new Set(bundleIdData.filter((record) => record))]);

    let chargeAmt = 0;
    let currency = "";
    workTicketData.map((material) => {
      //This is for C4S tickects for hardware materials, and to avoide the service materials staring with 13
      if (material.MMID.startsWith("11")) {
        if (material.MMID === data.MMID) {
          if (!currency) currency = material.materialChargeCurrency;
          chargeAmt = chargeAmt + parseFloat(material.customerMaterialCharge) * material.totalQty;
        }
      }
      if (material?.totalQty) {
        setTotalQuantity(material?.totalQty);
      }
    });
    let customerMaterialCharge = chargeAmt !== "" && chargeAmt !== undefined && chargeAmt !== null && !isNaN(chargeAmt) ? chargeAmt.toFixed(2) : "--";
    let materialChargeCurrency = `${currency || ""} ${customerMaterialCharge}`;
    setContractedPrice(materialChargeCurrency);
  }, []);

  const techRefIdsArr = useMemo(() => {
    let techRefIds = [];
    // if (workticketId.startsWith("W")) {
    //   vehicleInfoList.map((record) => {
    //     record.materialList.map((material) => {
    //       if (material.materialId === data.MMID && material.techRefId && !techRefIds.includes(material.techRefId)) {
    //         techRefIds = [...techRefIds, material.techRefId];
    //       }
    //     });
    //   });
    // } else {
    workTicketData.map((material) => {
      if (material.MMID === data.MMID && material.techRefId && !techRefIds.includes(material.techRefId)) {
        techRefIds = [...techRefIds, material.techRefId];
      }
    });
    // }
    return techRefIds;
  }, []);

  // condition added for CNS-RMA changes
  const isRMAChanges = !!cspCaseData?.CASEDetails?.length;

  return (
    <>
      <FlexColumn css={{ width: "100%" }}>
        <SLGridLayout role="grid" style={{ marginTop: "1rem", marginBottom: "1.5rem" }}>
          <SLRowLayout css={{ marginLeft: "0rem", marginRight: "0rem" }}>
            <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
              <TableWrapper>
                <DocumentFlowTable data={data} ticketType={ticketType} isRMAChanges={isRMAChanges} />
              </TableWrapper>
            </CompactCol>
          </SLRowLayout>
          <SLRowLayout css={{ marginLeft: "0rem", marginRight: "0rem" }}>
            <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
              {data.esnDetails?.length > 0 ? (
                <TableWrapper>
                  <CustomisedTable css={customTableHeader} role="table">
                    <TableHead role="row">
                      <TableHeader role="columnheader" id="col1">
                        <CustomSmallText bold>Tracking Number</CustomSmallText>
                      </TableHeader>
                      <TableHeader role="columnheader" id="col2">
                        <CustomSmallText bold>ESN</CustomSmallText>
                      </TableHeader>
                      <TableHeader role="columnheader" id="col3">
                        <CustomSmallText bold>Package Status</CustomSmallText>
                      </TableHeader>
                      <TableHeader role="columnheader" id="col4">
                        <CustomSmallText bold>Delivery Date</CustomSmallText>
                      </TableHeader>
                      <TableHeader role="columnheader" id="col5">
                        <CustomSmallText bold>Quantity</CustomSmallText>
                      </TableHeader>
                    </TableHead>
                    <TableBody role="rowgroup">
                      {data.esnDetails.map((esnDetail, index) => (
                        <TableRow key={index} role="row">
                          <Cell role="cell" id="col1">
                            <CustomSmallText>{esnDetail.trackingNum || "--"}</CustomSmallText>
                          </Cell>
                          <Cell role="cell" id="col2">
                            <CustomSmallText>
                              {esnDetail.esnList && esnDetail.esnList.length > 0
                                ? (() => {
                                    const validEsns = esnDetail.esnList
                                      .map((esn) => (esn ? esn.replace(/[\s,]+/g, "").trim() : ""))
                                      .filter((esn) => esn && esn !== "--" && esn !== "-");
                                    return validEsns.length > 0 ? validEsns.join(", ") : "";
                                  })()
                                : ""}
                            </CustomSmallText>
                          </Cell>
                          <Cell role="cell" id="col3">
                            <CustomSmallText>{esnDetail.status || "--"}</CustomSmallText>
                          </Cell>
                          <Cell role="cell" id="col4">
                            <CustomSmallText>
                              {esnDetail.deliveryDate && esnDetail.deliveryDate !== null ? esnDetail.deliveryDate : "--"}
                            </CustomSmallText>
                          </Cell>
                          <Cell role="cell" id="col5">
                            <CustomSmallText>{esnDetail.pkgQty !== "NA" && esnDetail.pkgQty ? esnDetail.pkgQty : "" || ""}</CustomSmallText>
                          </Cell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </CustomisedTable>
                </TableWrapper>
              ) : (
                <TableWrapper>
                  <CustomisedTable css={customTableHeader} role="table">
                    <TableHead role="row">
                      <TableHeader role="columnheader" id="col1">
                        <CustomSmallText bold>Tracking Number</CustomSmallText>
                      </TableHeader>
                      <TableHeader role="columnheader" id="col2">
                        <CustomSmallText bold>ESN</CustomSmallText>
                      </TableHeader>
                      <TableHeader role="columnheader" id="col3">
                        <CustomSmallText bold>Package Status</CustomSmallText>
                      </TableHeader>
                      <TableHeader role="columnheader" id="col4">
                        <CustomSmallText bold>Delivery Date</CustomSmallText>
                      </TableHeader>
                      <TableHeader role="columnheader" id="col5">
                        <CustomSmallText bold>Quantity</CustomSmallText>
                      </TableHeader>
                    </TableHead>
                    <TableBody role="rowgroup">
                      <TableRow role="row">
                        <Cell role="cell" id="col1">
                          <CustomSmallText>--</CustomSmallText>
                        </Cell>
                        <Cell role="cell" id="col2">
                          <CustomSmallText></CustomSmallText>
                        </Cell>
                        <Cell role="cell" id="col3">
                          <CustomSmallText>--</CustomSmallText>
                        </Cell>
                        <Cell role="cell" id="col4">
                          <CustomSmallText>--</CustomSmallText>
                        </Cell>
                        <Cell role="cell" id="col5">
                          <CustomSmallText>{totalQuantity || "--"}</CustomSmallText>
                        </Cell>
                      </TableRow>
                    </TableBody>
                  </CustomisedTable>
                </TableWrapper>
              )}
            </CompactCol>
          </SLRowLayout>

          {/* Carrier and Tracking URL Section */}
          <SLRowLayout css={{ width: "89.5%", margin: "auto", justifyContent: "space-between !important" }}>
            <div css={{ width: "48%" }}>
              <MaterialSOInfoTable data={formatCarriersData(data.carriers)} title="Carrier" property="carrier" />
            </div>
            <div css={{ width: "48%" }}>
              <MaterialSOInfoTable
                data={
                  data.esnDetails?.length > 0
                    ? data.esnDetails
                        .map((item) => item.trackingURL || "--")
                        .filter((url) => url !== "--")
                        .join(", ") || "--"
                    : data.trackingUrls || "--"
                }
                title="Tracking URL"
                property="trackingUrl"
              />
            </div>
          </SLRowLayout>

          <SLRowLayout css={{ marginLeft: "0rem", marginRight: "0rem" }}>
            <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
              {isRMAChanges && data.esnstobeRemoved && ticketType.toLowerCase() === "return" ? (
                <TableWrapper>
                  <ReturnESNTable data={data.esnstobeRemoved} />
                </TableWrapper>
              ) : null}
            </CompactCol>
          </SLRowLayout>

          <SLRowLayout>
            <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
              <SLGridLayout>
                <SLRowLayout css={{ marginLeft: "0rem", marginRight: "0rem" }}>
                  <Col colSizes={{ mobile: 1, tablet: 3, desktop: 3 }}>
                    <SmallText css={{ marginTop: "1.5rem" }}> Tech reference ID</SmallText>
                    <UltraMediumText fontWeight="normal" marginTop="12px !important" style={{ textWrap: "balance" }}>
                      {/* {techRefIdsArr.length ? techRefIdsArr.join(",") : "--"} */}
                      {/* VZC42148-1709 */}
                      {data.techRefId ? data.techRefId : "--"}
                    </UltraMediumText>
                  </Col>
                  <Col colSizes={{ mobile: 1, tablet: 3, desktop: 3 }}>
                    <SmallText css={{ marginTop: "1.5rem" }}> Delivery Block </SmallText>
                    <UltraMediumText fontWeight="normal" marginTop="12px !important">
                      {data.deliveryBlock ? data.deliveryBlock : "--"}
                    </UltraMediumText>
                  </Col>
                  <Col colSizes={{ mobile: 1, tablet: 3, desktop: 3 }}>
                    <SmallText css={{ marginTop: "1.5rem" }}>Contract </SmallText>
                    <UltraMediumText fontWeight="normal" marginTop="12px !important">
                      {erpProviderNumber}
                    </UltraMediumText>
                  </Col>
                  <Col colSizes={{ mobile: 1, tablet: 3, desktop: 3 }}>
                    <SmallText css={{ marginTop: "1.5rem" }}>ATP Relevant</SmallText>
                    <UltraMediumText fontWeight="normal" marginTop="12px !important">
                      Yes
                    </UltraMediumText>
                  </Col>
                </SLRowLayout>
              </SLGridLayout>
            </CompactCol>
          </SLRowLayout>
          <SLRowLayout>
            <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
              <SLGridLayout>
                <SLRowLayout css={{ marginLeft: "0rem", marginRight: "0rem" }}>
                  <Col colSizes={{ mobile: 1, tablet: 3, desktop: 3 }}>
                    <SmallText css={{ marginTop: "1.5rem" }}> PGI Date </SmallText>
                    <UltraMediumText fontWeight="normal" marginTop="12px !important">
                      {data.pgiDate ? moment(data.pgiDate, "YYYYMMDD").format("MMM D, yyyy") : `--`}
                    </UltraMediumText>
                  </Col>
                  <Col colSizes={{ mobile: 1, tablet: 3, desktop: 3 }}>
                    <SmallText css={{ marginTop: "1.5rem" }}> PGI Quantity</SmallText>
                    <UltraMediumText fontWeight="normal" marginTop="12px !important">
                      {data.pgiQty ? data.pgiQty : "--"}
                    </UltraMediumText>
                  </Col>
                  <Col colSizes={{ mobile: 1, tablet: 3, desktop: 3 }}>
                    <SmallText css={{ marginTop: "1.5rem" }}> Contracted Price</SmallText>
                    <UltraMediumText fontWeight="normal" marginTop="12px !important">
                      {contractedPrice ?? "--"}
                    </UltraMediumText>
                  </Col>
                  <Col colSizes={{ mobile: 1, tablet: 3, desktop: 3 }}>
                    <SmallText css={{ marginTop: "1.5rem" }}> Customer PO Number </SmallText>
                    <UltraMediumText fontWeight="normal" marginTop="12px !important">
                      {customerPONumber}
                    </UltraMediumText>
                  </Col>
                </SLRowLayout>
              </SLGridLayout>
            </CompactCol>
          </SLRowLayout>
          <SLRowLayout css={{ marginBottom: "1.5rem" }}>
            <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
              <SLGridLayout>
                <SLRowLayout css={{ marginLeft: "0rem", marginRight: "0rem" }}>
                  <Col colSizes={{ mobile: 1, tablet: 3, desktop: 3 }}>
                    <SmallText css={{ marginTop: "1.5rem" }}> Bundle Name </SmallText>
                    <UltraMediumText fontWeight="normal" marginTop="12px !important">
                      {bundleId.length ? bundleId.map((item, idx) => item && (idx === bundleId.length - 1 ? item : `${item}, `)) : "--"}
                    </UltraMediumText>
                  </Col>
                  <Col colSizes={{ mobile: 1, tablet: 3, desktop: 3 }}>
                    <SmallText css={{ marginTop: "1.5rem" }}> Order Type </SmallText>
                    <UltraMediumText fontWeight="normal" marginTop="12px !important">
                      {data.orderType ? data.orderType : "--"}
                    </UltraMediumText>
                  </Col>
                  <Col colSizes={{ mobile: 1, tablet: 3, desktop: 3 }}>
                    <SmallText css={{ marginTop: "1.5rem" }}> Contract Override </SmallText>
                    <UltraMediumText fontWeight="normal" marginTop="12px !important">
                      {data.contractOverride ? data.contractOverride : "--"}
                    </UltraMediumText>
                  </Col>
                </SLRowLayout>
              </SLGridLayout>
            </CompactCol>
          </SLRowLayout>
        </SLGridLayout>
      </FlexColumn>
    </>
  );
};

export default MMIDFlyOutView;
